export enum MessageShortcutType {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}
